module.exports = __webpack_public_path__ + "static/gold-dragon-hidecarved-cee2ff5399a7cedf85f76e4b99175f36.png";